import CheckboxIcon from '../../../assets/forms/checkbox.svg';
import DateIcon from '../../../assets/forms/date.svg';
import LongTextIcon from '../../../assets/forms/long-text.svg';
import NumberIcon from '../../../assets/forms/number.svg';
import RadioIcon from '../../../assets/forms/radio.svg';
import SeparatorIcon from '../../../assets/forms/separator.svg';
import SignatureIcon from '../../../assets/forms/signature.svg';
import TextIcon from '../../../assets/forms/text.svg';

import { FormFieldTypes } from '../../../models';

export const fieldIconMapper = (type: FormFieldTypes) => {
  switch (type) {
    case FormFieldTypes.text:
      return TextIcon;
    case FormFieldTypes.date:
      return DateIcon;
    case FormFieldTypes.multipleSelection:
      return CheckboxIcon;
    case FormFieldTypes.longText:
      return LongTextIcon;
    case FormFieldTypes.number:
      return NumberIcon;
    case FormFieldTypes.singleSelection:
      return RadioIcon;
    case FormFieldTypes.separator:
      return SeparatorIcon;
    case FormFieldTypes.signature:
      return SignatureIcon;
  }
};
